import Section from './Section';
import moment from 'moment';

export default class SectionRelation {

    static fromData(data) {
        if (!data) {
            return;
        }

        let sectionRelation = new SectionRelation();
        sectionRelation.id = data.id;
        sectionRelation.section = Section.fromData(data.section.data);
        sectionRelation.start = moment(data.start);
        sectionRelation.end = data.end !== null ? moment(data.end) : null;

        Object.seal(sectionRelation);
        return sectionRelation;
    }

    toData() {
        return {
            id: this.id,
            section: this.section,
            start: this.start.format('DD.MM.YYYY'),
            end: this.end === null ? null : this.end.format('DD.MM.YYYY'),
        };
    }

    isEmpty() {
        return !this.start && !this.end && !this.section;
    }

    isValid() {
        if (!this.section) {
            return false;
        }

        if (!this.start) {
            return false;
        }

        if (this.end && moment(this.start, 'DD.MM.YYYY') > moment(this.end, 'DD.MM.YYYY')) {
            return false;
        }

        return true;
    }

    formattedEnd() {
        return this.end === null ? null : this.end.format('DD.MM.YYYY');
    }
}
